import React from 'react';
import Search from '../../components/Search';
import ScheduleItem from './ScheduleItem';
import ScheduleItemMin from './ScheduleItemMin';

function ScheduleItems({ scheduleChanger, config, items, onSearch }) {
  const [minimize, ] = React.useState(config.minimize);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Search
        onSearch={onSearch}
        placeholder='Search by title or description'
      />
      <div
        className={`schedule ${minimize ? 'schedule-min' : ''}`}
      >
        {items.map((s) => (
          minimize ? (
            <ScheduleItemMin scheduleChanger={scheduleChanger} config={config} schedule={s} key={s.id} />
          ) : (
            <ScheduleItem scheduleChanger={scheduleChanger} config={config} schedule={s} key={s.id} />
          )
        ))}
      </div>
    </div>
  );
}

export default ScheduleItems;
